'use client'

import { useEffect } from 'react'

// Counts presses of an AI post's banner button on AIBlogWrite's dashboard
// ("CTA clicks"): the same job as the package's own track.js, which isn't
// exported, scoped to the AI post body on our article page. Once per page,
// sent as the browser leaves for the link; automated browsers are skipped.
// Renders nothing.
export default function AiCtaClicks({ url }) {
  useEffect(() => {
    if (!url || navigator.webdriver) return undefined
    let counted = false
    const onPress = (event) => {
      const button = event.target?.closest?.('.blog-ai-content .octopi-cta__button')
      if (!button || counted) return
      counted = true
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(url)) return
        fetch(url, { method: 'POST', keepalive: true, credentials: 'omit' })
      } catch {
        // A click not counted is fine; a broken page is not.
      }
    }
    // A plain click, and a middle click (opening the link in a new tab).
    document.addEventListener('click', onPress, true)
    document.addEventListener('auxclick', onPress, true)
    return () => {
      document.removeEventListener('click', onPress, true)
      document.removeEventListener('auxclick', onPress, true)
    }
  }, [url])
  return null
}
